export * from './queryKeys';

import { Obj } from "@/types";
export enum OrderStatus {
  NEW = 1,
  PENDING = 2,
  IN_PRODUCTION = 736000001,
  CREDIT_LIMIT_EXCEEDED = 736000002,
  AWAITING_PAYMENT = 736000003,
  READY_TO_PRODUCTION = 736000004,
  Cancelled = 4,
  Completed = 100001,
}
export enum OrderStateCode {
  Active = 0,
  Submitted = 1,
  Cancelled = 2,
  Fulfilled = 3,
  Invoice = 4,
}
export enum PaymentStatus {
  PAYMENT_LINK_SENT = 1,
  PAYMENT_COMPLETED = 2,
  DEPOSIT_PAID = 3,
  PARTIALLY_PAID = 4,
  OVERDUE = 5,
  CREDIT = 6,
  PAYMENT_FAILED = 7,
}
// Order status labels
export const ORDER_STATUS_LABELS: Obj = {
  [OrderStatus.NEW]: "New",
  [OrderStatus.PENDING]: "Pending",
  [OrderStatus.IN_PRODUCTION]: "In Production",
  [OrderStatus.CREDIT_LIMIT_EXCEEDED]: "Credit Limit Approval",
  [OrderStatus.AWAITING_PAYMENT]: "Awaiting Payment",
  [OrderStatus.READY_TO_PRODUCTION]: "Order Received",
  [OrderStatus.Cancelled]: "Cancelled",
  [OrderStatus.Completed]: "Completed",
};

// Order status options
export const ORDER_STATUS_OPTIONS = [
  { value: OrderStatus.NEW, label: ORDER_STATUS_LABELS[OrderStatus.NEW] },
  { value: OrderStatus.PENDING, label: ORDER_STATUS_LABELS[OrderStatus.PENDING] },
  { value: OrderStatus.IN_PRODUCTION, label: ORDER_STATUS_LABELS[OrderStatus.IN_PRODUCTION] },
  { value: OrderStatus.CREDIT_LIMIT_EXCEEDED, label: ORDER_STATUS_LABELS[OrderStatus.CREDIT_LIMIT_EXCEEDED] },
  { value: OrderStatus.AWAITING_PAYMENT, label: ORDER_STATUS_LABELS[OrderStatus.AWAITING_PAYMENT] },
  { value: OrderStatus.READY_TO_PRODUCTION, label: ORDER_STATUS_LABELS[OrderStatus.READY_TO_PRODUCTION] },
  { value: OrderStatus.Completed, label: ORDER_STATUS_LABELS[OrderStatus.Completed] },
  { value: OrderStatus.Cancelled, label: ORDER_STATUS_LABELS[OrderStatus.Cancelled] },
];

// Order status colors (Ant Design Tag colors)
export const ORDER_STATUS_COLORS: Obj = {
  [OrderStatus.NEW]: "blue",           // blue — fresh, informational
  [OrderStatus.PENDING]: "gold",        // gold — waiting/on hold
  [OrderStatus.IN_PRODUCTION]: "processing", // blue spinner — actively being worked
  [OrderStatus.CREDIT_LIMIT_EXCEEDED]: "success",  // green — approved
  [OrderStatus.AWAITING_PAYMENT]: "purple",      // purple — payment action needed
  [OrderStatus.READY_TO_PRODUCTION]: "cyan",     // cyan — ready, positive momentum
  [OrderStatus.Cancelled]: "error",              // red — cancelled
  [OrderStatus.Completed]: "success",            // green — done
};

// Order status hex colors for stat cards (matching Ant Design colors)
export const ORDER_STATUS_HEX_COLORS: Obj = {
  [OrderStatus.NEW]: "#1677ff",          // blue
  [OrderStatus.PENDING]: "#d48806",      // gold
  [OrderStatus.IN_PRODUCTION]: "#1677ff", // blue
  [OrderStatus.CREDIT_LIMIT_EXCEEDED]: "#52c41a", // green
  [OrderStatus.AWAITING_PAYMENT]: "#722ed1",      // purple
  [OrderStatus.READY_TO_PRODUCTION]: "#13c2c2",   // cyan
  [OrderStatus.Cancelled]: "#ff4d4f",             // red
  [OrderStatus.Completed]: "#52c41a",             // green
};

// Payment status options
export const PAYMENT_STATUS_OPTIONS = [
  { value: PaymentStatus.PAYMENT_LINK_SENT, label: "Payment Link Sent" },
  { value: PaymentStatus.PAYMENT_COMPLETED, label: "Payment Completed" },
  { value: PaymentStatus.DEPOSIT_PAID, label: "Deposit Paid" },
  { value: PaymentStatus.PARTIALLY_PAID, label: "Partially Paid" },
  { value: PaymentStatus.OVERDUE, label: "Overdue" },
  { value: PaymentStatus.CREDIT, label: "Credit" },
  { value: PaymentStatus.PAYMENT_FAILED, label: "Payment Failed" },
];

// Payment status labels
export const PAYMENT_STATUS_LABELS: Obj = {
  [PaymentStatus.PAYMENT_LINK_SENT]: "Payment Link Sent",
  [PaymentStatus.PAYMENT_COMPLETED]: "Payment Completed",
  [PaymentStatus.DEPOSIT_PAID]: "Deposit Paid",
  [PaymentStatus.PARTIALLY_PAID]: "Partially Paid",
  [PaymentStatus.OVERDUE]: "Overdue",
  [PaymentStatus.CREDIT]: "Credit",
  [PaymentStatus.PAYMENT_FAILED]: "Payment Failed",
};

// Payment status colors (Ant Design Tag colors)
export const PAYMENT_STATUS_COLORS: Obj = {
  [PaymentStatus.PAYMENT_LINK_SENT]: "purple",    // purple — link sent, awaiting action
  [PaymentStatus.PAYMENT_COMPLETED]: "success",   // green — fully paid
  [PaymentStatus.DEPOSIT_PAID]: "processing",     // blue — in progress
  [PaymentStatus.PARTIALLY_PAID]: "geekblue",     // dark blue — partial, distinct from deposit
  [PaymentStatus.OVERDUE]: "red",                 // red — urgent
  [PaymentStatus.CREDIT]: "lime",                 // lime — credit account, positive
  [PaymentStatus.PAYMENT_FAILED]: "volcano",      // volcano — failure, distinct red from overdue
};

// Common constants
export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_STARTING_PAGE = 1;
